/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import TextField from '@material-ui/core/TextField';
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';
import {
  checkQuarterValidation,
  compareQtrs,
  convertQuaterToDate,
} from '../../../../../SharedModules/CommonUtilities/commonUtilities';
import { compareTwoDates } from '../../../../../SharedModules/DateUtilities/DateUtilities';
import * as constantMessageData from '../../../../../SharedModules/Errors/constantMessageData';
import {
  dispatchDrugTable,
  handleErrorMessages,
  maintainContractActions,
} from '../../store/actions';
import { autoFormateDate } from '../../../../../SharedModules/utilities/utilities';

export default (props) => {
  const dispatch = useDispatch();
  const maintainContractState = useSelector(
    (state) => state.sharedState.ContractReducer.maintainContractState
  );
  const getDrugFamilyTable = useSelector(
    (state) => state.sharedState.ContractReducer.getDrugFamilyTable
  );
  const errorMessagesFromRedux = useSelector((state) => {
    return state?.sharedState?.ContractReducer?.errorMessagesInRedux;
  });
  const { colId } = props.column;
  const { rowIndex, hasAccess, isEnablebyRole } = props;
  // handing on change text boxes event
  const handleChange = (e) => {
    const newObj = [...getDrugFamilyTable];
    props.node.setDataValue(colId, e.target.value);
    const obj = newObj[rowIndex];
    if (colId === 'startquarter') {
      obj.startquarter = e.target.value;
    } else if (colId === 'endquarter') {
      obj.endquarter = e.target.value;
    }
    dispatch(dispatchDrugTable(obj, rowIndex, colId, 'Add'));
    dispatch(
      maintainContractActions({
        ...maintainContractState,
        showSaveButton: 'Yes',
      })
    );
    let localErr = errorMessagesFromRedux || [];
    localErr = localErr?.filter(
      (item) => item.message !== constantMessageData.CONTRACT_NO_CALCULATED_URA
    );
    dispatch(handleErrorMessages([...new Set(localErr)]));
  };

  const doQuartersOverlap = (dates) => {
    let myArr = [...dates];
    myArr = myArr.map((el) => {
      if (!el.endQtr) {
        return {
          ...el,
          startQtr: new Date(el.startQtr),
          endQtr: new Date('12/31/9999'),
        };
      }
      return {
        ...el,
        startQtr: new Date(el.startQtr),
        endQtr: new Date(el.endQtr),
      };
    });
    let overlap = [];

    for (let i = 0; i < myArr.length; i++) {
      for (let j = i + 1; j < myArr.length; j++) {
        // Check if the date ranges overlap
        if (
          myArr[i].drugfamilyname === myArr[j].drugfamilyname &&
          myArr[i].startQtr <= myArr[j].endQtr &&
          myArr[j].startQtr <= myArr[i].endQtr
        ) {
          // Add the indexes of the overlapping objects to the array
          overlap.push(i, j);
        }
      }
    }
    return (overlap = [...new Set(overlap)]);
  };

  // handing on blur text boxes event
  const handleOnBlurEvent = (value) => {
    const newObj = [...getDrugFamilyTable];
    const val = autoFormateDate(value?.toUpperCase());

    // overlap validation
    let tempArr = [...newObj];
    tempArr = tempArr.map((el) => {
      return {
        ...el,
        startQtr: convertQuaterToDate(el.startquarter),
        endQtr: convertQuaterToDate(el.endquarter),
      };
    });

    const quarterOverlap = doQuartersOverlap(tempArr);
    let localErr = errorMessagesFromRedux || [];
    if (val && !_.isEmpty(val) && !_.isNaN(val)) {
      if (checkQuarterValidation(val)) {
        localErr = localErr?.filter(
          (item) => item.fieldName !== `${colId}${rowIndex}`
        );
        props.node.setDataValue(colId, val?.toUpperCase());
        if (colId === 'startquarter') {
          newObj[rowIndex].startQtrErr = false;
        }
        if (colId === 'endquarter') {
          newObj[rowIndex].endQtrErr = false;
        }
        dispatch(dispatchDrugTable(newObj[rowIndex], rowIndex, colId, 'Add'));
        if (
          props.data?.endquarter !== '' &&
          props.data?.endquarter !== undefined &&
          colId === 'startquarter'
        ) {
          if (
            compareQtrs(val, props.data?.endquarter) &&
            checkQuarterValidation(props.data?.endquarter)
          ) {
            localErr = localErr?.filter(
              (item) => item.fieldName !== `${colId}${rowIndex}`
            );
            props.node.setDataValue(colId, val?.toUpperCase());
            newObj[rowIndex].endQtrErr = true;
            dispatch(
              dispatchDrugTable(newObj[rowIndex], rowIndex, colId, 'Add')
            );
            localErr.push({
              fieldName: `${colId}${rowIndex}`,
              errorType: 'rangeInvalid',
              tabName: 'DrugFamily',
              rowIndex: `${colId}${rowIndex}`,
              message: `${constantMessageData.END_QTR_GRATER_START_QTR_ERR} ${
                rowIndex + 1
              }.`,
            });
          } else {
            localErr = localErr?.filter(
              (item) => item.fieldName !== `${colId}${rowIndex}`
            );
            const endQtrErr = localErr?.filter(
              (item) => item.fieldName === `endquarter${rowIndex}`
            );
            if (endQtrErr.length > 0) {
              newObj[rowIndex].endQtrErr = true;
            } else newObj[rowIndex].endQtrErr = false;
            dispatch(
              dispatchDrugTable(newObj[rowIndex], rowIndex, colId, 'Add')
            );
          }
        } else if (props.data?.startquarter !== '' && colId === 'endquarter') {
          if (compareQtrs(props.data?.startquarter, val)) {
            localErr = localErr?.filter(
              (item) => item.fieldName !== `${colId}${rowIndex}`
            );
            props.node.setDataValue(colId, val?.toUpperCase());
            newObj[rowIndex].endQtrErr = true;
            dispatch(
              dispatchDrugTable(newObj[rowIndex], rowIndex, colId, 'Add')
            );
            localErr.push({
              fieldName: `${colId}${rowIndex}`,
              errorType: 'rangeInvalid',
              tabName: 'DrugFamily',
              rowIndex: `${colId}${rowIndex}`,
              message: `${constantMessageData.END_QTR_GRATER_START_QTR_ERR} ${
                rowIndex + 1
              }.`,
            });
          } else if (
            maintainContractState.contractEndDate !== '' &&
            maintainContractState.contractEndDate !== null &&
            maintainContractState.contractEndDate !== undefined
          ) {
            const endDrugFamilyDate = convertQuaterToDate(val);
            localErr = localErr?.filter(
              (item) => item.fieldName !== `${colId}${rowIndex}`
            );
            props.node.setDataValue(colId, val?.toUpperCase());
            const setError = !compareTwoDates(
              endDrugFamilyDate,
              maintainContractState.contractEndDate
            );
            newObj[rowIndex].endQtrErr = setError;
            dispatch(
              dispatchDrugTable(newObj[rowIndex], rowIndex, colId, 'Add')
            );
            if (setError)
              localErr.push({
                fieldName: `${colId}${rowIndex}`,
                errorType: 'endQtrInvalid',
                tabName: 'DrugFamily',
                rowIndex: `${colId}${rowIndex}`,
                message: `${
                  constantMessageData.CONTRACT_END_QUARTER_GRT_END_DATE
                } ${rowIndex + 1}.`,
              });
          } else {
            localErr = localErr?.filter(
              (item) => item.fieldName !== `${colId}${rowIndex}`
            );
            newObj[rowIndex].endQtrErr = false;
            dispatch(
              dispatchDrugTable(newObj[rowIndex], rowIndex, colId, 'Add')
            );
          }
        }
        if (quarterOverlap.length > 0) {
          const array = [];
          let msg = '';
          const errList = [];

          quarterOverlap.forEach((li, index) => {
            msg += `Row ${li + 1} ${
              quarterOverlap.length !== index + 1 ? ' and ' : ''
            }`;
          });
          newObj.filter((data, index) => {
            if (quarterOverlap.includes(index)) {
              errList.push({
                colId: colId,
                rowId: index,
              });
            }
          });

          array.push({
            fieldName: `${colId}`,
            errorType: 'quarterOverlap',
            tabName: 'DrugFamily',
            message: `${'Start and End Date Overlap on'} ${msg}.`,
            errList: errList,
          });
          const temArr = localErr.filter((data) => {
            if (data.errorType !== 'quarterOverlap') return data;
          });
          localErr = [...temArr, ...array];
        } else {
          localErr = localErr.filter((data) => {
            if (data.errorType !== 'quarterOverlap') return data;
          });
        }
      } else {
        localErr = localErr?.filter(
          (item) => item.fieldName !== `${colId}${rowIndex}`
        );
        props.node.setDataValue(colId, value?.toUpperCase());
        if (colId === 'startquarter') {
          newObj[rowIndex].startQtrErr = true;
        }
        if (colId === 'endquarter') {
          newObj[rowIndex].endQtrErr = true;
        }
        dispatch(dispatchDrugTable(newObj[rowIndex], rowIndex, colId, 'Add'));
        localErr.push({
          fieldName: `${colId}${rowIndex}`,
          errorType: 'invalidQuarterFormat',
          tabName: 'DrugFamily',
          rowIndex: `${colId}${rowIndex}`,
          message:
            colId === 'startquarter'
              ? `${constantMessageData.CONTRACT_START_QUARTER_FORMAT_ERROR} ${
                  rowIndex + 1
                }.`
              : `${constantMessageData.CONTRACT_END_QUARTER_FORMAT_ERROR} ${
                  rowIndex + 1
                }.`,
        });
      }
    } else {
      if (colId === 'startquarter') {
        newObj[rowIndex].startQtrErr = false;
      }
      if (colId === 'endquarter') {
        newObj[rowIndex].endQtrErr = false;
      }
      localErr = localErr?.filter(
        (item) => item.fieldName !== `${colId}${rowIndex}`
      );
    }

    dispatch(handleErrorMessages([...new Set(localErr)]));
  };

  const checkoverlap = (key, id) => {
    let obj = {};
    if (errorMessagesFromRedux?.length > 0) {
      errorMessagesFromRedux.find((data) => {
        if (data.errorType === 'quarterOverlap') {
          data.errList.find((li) => {
            if (li.colId === key && li.rowId === id) {
              obj = data;
            }
          });
        }
      });
      if (Object.keys(obj)?.length > 0) {
        return true;
      }
      return false;
    }
  };

  return (
    <div data-testid='log-check-text-box'>
      <TextField
        label={`label_${props.column.colId}`}
        id={`label_${props.column.colId}`}
        fullWidth
        placeholder=''
        InputLabelProps={{
          shrink: true,
        }}
        inputProps={{ maxLength: 16, id: `label_${props.column.colId}` }}
        value={props.value}
        onChange={(e) => handleChange(e)}
        onBlur={(e) => handleOnBlurEvent(e.target.value)}
        disabled={hasAccess === false || isEnablebyRole === false}
        className={
          colId === 'startquarter'
            ? (getDrugFamilyTable &&
                getDrugFamilyTable[rowIndex] &&
                getDrugFamilyTable[rowIndex].startQtrErr !== undefined &&
                getDrugFamilyTable[rowIndex].startQtrErr) ||
              checkoverlap('startquarter', rowIndex)
              ? 'td-active-cell tBill-validate frr-display-hidden-label'
              : 'frr-display-hidden-label'
            : colId === 'endquarter'
            ? (getDrugFamilyTable &&
                getDrugFamilyTable[rowIndex] &&
                getDrugFamilyTable[rowIndex].endQtrErr !== undefined &&
                getDrugFamilyTable[rowIndex].endQtrErr) ||
              checkoverlap('endquarter', rowIndex)
              ? 'td-active-cell tBill-validate frr-display-hidden-label'
              : 'frr-display-hidden-label'
            : 'frr-display-hidden-label'
        }
      />
    </div>
  );
};
